import checkout from "layouts/user/components/user-details/schemas/userForm";

const {
  formField: {
    organization,
    subOrganization,
    classData,
    email,
    userType,
    name,
    surname,
    nickName,
    studentNo,
    allBooksEnabled,
  },
} = checkout;

export default {
  [organization.name]: null,
  [subOrganization.name]: null,
  [classData.name]: null,
  [email.name]: "",
  [userType.name]: null,
  [name.name]: "",
  [surname.name]: "",
  [nickName.name]: "",
  [studentNo.name]: "",
  [allBooksEnabled.name]: false,
};
